import { t } from '@lingui/core/macro';
import jQuery from 'jquery';

(function extendValidatorMessages($: any) {
  $.extend($.validator.messages, {
    required: t`This field is required.`,
    remote: t`Please fix this field.`,
    email: t`Enter a valid email address.`,
    url: t`Please enter a valid URL.`,
    date: t`Please enter a valid date.`,
    dateISO: t`Please enter a valid date (ISO).`,
    number: t`Please enter a valid number.`,
    digits: t`Please enter only digits.`,
    creditcard: t`Please enter a valid credit card number.`,
    equalTo: t`Please enter the same value again.`,
    accept: t`Please enter a value with a valid extension.`,
    maxlength: (maxLength) => t`Please enter no more than ${maxLength} characters.`,
    minlength: (minLength) => t`Please enter at least ${minLength} characters.`,
    rangelength: ([minLength, maxLength]) =>
      t`Please enter a value between ${minLength} and ${maxLength} characters long.`,
    range: ([minValue, maxValue]) => t`Please enter a value between ${minValue} and ${maxValue}.`,
    max: (maxValue) => t`Please enter a value less than or equal to ${maxValue}.`,
    min: (minValue) => t`Please enter a value greater than or equal to ${minValue}.`,
  });
})(jQuery);
